export default "__VITE_ASSET__25639c3c__"